import { ISelectedListIdsSet } from './types';
import { AT_SELECTED_LIST_IDS_SET } from './constatns';
import { TListId } from '../../../../../../types/types';

export const selectedListIdsSet = (
    selectedListIds: TListId[],
    isMultiselect?: boolean,
): ISelectedListIdsSet => ({
    type: AT_SELECTED_LIST_IDS_SET,
    isMultiselect,
    selectedListIds,
});
